"use strict";
const Game = require('./Game.js').Game;
const element = document.getElementById('game');
var game = new Game(element);


/** WEBPACK FOOTER **
 ** ./~/jshint-loader!./src/entry.js
 **/